/**
 * Translations for names the database stores and the portal shows: species, pen types, site
 * types and lice types. The stored name is the last segment of the key, and i18next falls back
 * to it, so a type inserted into the database shows its stored name until someone translates it.
 */
export type DataLabelGroup = 'fishTypes' | 'cageTypes' | 'locationTypes' | 'liceTypes';

export interface DataLabel {
    key: string;
    defaultValue: string;
}

type Translate = (key: string, options: { defaultValue: string }) => string;

export function dataLabel(group: DataLabelGroup, name: string): DataLabel {
    return { key: `common.${group}.${name}`, defaultValue: name };
}

export function translateDataLabel(t: Translate, group: DataLabelGroup, name: string): string {
    const label = dataLabel(group, name);
    return t(label.key, { defaultValue: label.defaultValue });
}
